import { useFetchPost } from "hooks/fetch/useFetchPost";
import { useMemo } from "react";

export function useDismissMultipleAlerts(onCompleted = undefined) {
  const url = useMemo(() => `alerts/ignore`, []);

  const { loading, error, data, postCallback } = useFetchPost(url, onCompleted);

  return { loading, error, data, postDismissMultipleCallback: postCallback };
}
